import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

/**
 * Confirmation dialog for mosaic actions that require confirmation. e.g.
 * deleting a row in a table.
 */
@ngCore.Component({
  imports: [
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    ds.button.Component,
  ],
  selector: 'atn-mosaic-confirmation-dialog',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature} */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  public cancelClickHandler() {
    const requestAction =
      this.currentRendering.subfeatures.actions.selectors.confirmationRequest.asSignal()
    if (requestAction) {
      this.currentRendering.subfeatures.actions.actions.confirmAction.cancellation
        .from(requestAction)
        .dispatch({
          request: requestAction.data,
        })
      return
    }
    console.warn(
      'RequestAction not present, cannot dispatching cancellation action',
    )
  }

  public confirmClickHandler() {
    const requestAction =
      this.currentRendering.subfeatures.actions.selectors.confirmationRequest.asSignal()
    if (requestAction) {
      this.currentRendering.subfeatures.actions.actions.confirmAction.success
        .from(requestAction)
        .dispatch({
          request: requestAction.data,
        })
      return
    }
    console.warn(
      'RequestAction not present, cannot dispatching cancellation action',
    )
  }
}
